import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** shadcn/ui's class merge helper — required by generated components. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** A file's bytes as base64, minus the data-URL prefix the reader puts on — for an upload. */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '')
    reader.onerror = () => reject(reader.error ?? new Error('Could not read the file'))
    reader.readAsDataURL(file)
  })
}
